import React from 'react';
import Navbar from '../Navbar_module/Navbar';
import Home_top from './Home_top';
import Top_selling from './Home_middle';
import Check_out from './home_bottom/check_out';
import Footer from './Footerr/footer'
import { AuthProvider } from '../../Auth';
import Top_selling_cards from './Top_selling_cards';
import './style.css';

export default function Homemain(){
    return(<>

    {/* <Navbar/>      */}
    <Home_top/> 

    <Top_selling/>   
    

    <Check_out/>
    <Footer/>
    
  
    </>)

       
   

} 